import { createReducer } from "@reduxjs/toolkit";

import {
  getSuggestionsFailure,
  getSuggestionsSuccess,
  getSuggestions,
  getSuggestionsPortion,
  getSuggestionsPortionSuccess,
  getSuggestionsPortionFailure,
} from "./actions";
import {
  followCreatorSuccess,
  unfollowCreatorSuccess,
} from "../creatorProfile/actions";

const initialState = {
  data: [],
  nextOffset: undefined,
  totalCount: undefined,
  error: null,
  isLoading: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getSuggestions.type, (state) => ({
      ...state,
      error: null,
      isLoading: true,
    }))
    .addCase(getSuggestionsSuccess.type, (state, { payload }) => ({
      ...state,
      ...payload,
      data: payload.data,
      isLoading: false,
      error: null,
    }))
    .addCase(getSuggestionsFailure.type, (state, { payload }) => ({
      ...state,
      error: payload,
      isLoading: false,
    }))
    .addCase(getSuggestionsPortion.type, (state) => ({
      ...state,
      error: null,
      isLoading: true,
    }))
    .addCase(getSuggestionsPortionSuccess.type, (state, { payload }) => ({
      ...state,
      ...payload,
      data: [...state.data, ...payload.data],
      isLoading: false,
      error: null,
    }))
    .addCase(getSuggestionsPortionFailure.type, (state, { payload }) => ({
      ...state,
      error: payload,
      isLoading: false,
    }))
    .addCase(followCreatorSuccess.type, (state, { payload }) => {
      const { userId } = payload;
      const { data } = state;

      const followingIndex = data.findIndex((item) => item?.id === userId);

      const item = data.at(followingIndex);

      if (item) {
        item.isFollowed = true;
      }

      return state;
    })
    .addCase(unfollowCreatorSuccess.type, (state, { payload }) => {
      const { userId } = payload;
      const { data } = state;

      const followingIndex = data.findIndex((item) => item?.id === userId);

      const item = data.at(followingIndex);

      if (item) {
        item.isFollowed = false;
      }
      return state;
    });
});
